import React from 'react';
import I18n from 'i18n-js';
import { Text } from 'react-native';

const StatusText = ({ text, font, scale, style, C, color = 'Label/Light/Tertiary' }) => {
  if (!text) {
    return null;
  }

  return (
    <Text
      style={[
        font['Subhead 2'],
        {
          color: C(color),
          width: '100%',
          textAlign: 'center',
          fontSize: scale(14),
          lineHeight: scale(20),
          fontWeight: '400',
        },
        style,
      ]}
      numberOfLines={1}
      ellipsizeMode="middle"
      adjustsFontSizeToFit={true}
    >
      {I18n.t(text)}
    </Text>
  );
};

export default StatusText;
